// extracted by mini-css-extract-plugin
module.exports = {"search-buttons":"_-web-client-js-react-components-principals-___Search-module__search-buttons___1Suzh"};